import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { CarSelectData } from "@/model/CarSelection";

const initialState: CarSelectData = {
  sknUketsukeExtendsId: 0,
  uketsukeCd: "",
  jidoushaShubetsu: null,
  youto: null,
  kudouHoushiki: null,
  katashikiShiteiNo: null,
  ruibetsuKubunNo: null,
  katashiki: null,
  engineKatashiki: null,
  fuelKbn: null,
  shiftKbn: null,
  meterPanelAlert: null,
  fTireSizeWize: null,
  fTireSizeHenpei: null,
  fTireSizeInchi: null,
  fTireSizeIndex: null,
  rTireSizeWize: null,
  rTireSizeHenpei: null,
  rTireSizeInchi: null,
  rTireSizeIndex: null,
  isWideTire: null,
  fLeftTireNokorimizo: null,
  fRightTireNokorimizo: null,
  rLeftTireNokorimizo: null,
  rRightTireNokorimizo: null,
  brake: null,
  kakyukiKbn: null,
  shashuRenban: null,
  soukouKm: null,
  soukouMile: null,
  soukouUnitKbn: null,
  soukouBikouKbn: null,
  sknSaiteiChijouKou: null,
  fRightTireHibi: 0,
  fLeftTireHibi: 0,
  rRightTireHibi: 0,
  rLeftTireHibi: 0,
  fTireSizeRadial: null,
  rTireSizeRadial: null,
  fTireSizeSpeed: null,
  rTireSizeSpeed: null,
  fTireSizeInput: null,
  rTireSizeInput: null,
  fTireSizePlyRating: null,
  rTireSizePlyRating: null
};

const actions: ActionTree<CarSelectData, any> = {
  setState(
    { commit }: ActionContext<CarSelectData, any>,
    payload: CarSelectData
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<CarSelectData, any>): void {
    commit("clearState");
  },
  updateSoukou(
    { commit }: ActionContext<CarSelectData, any>,
    payload: number
  ): void {
    commit("updateSoukou", payload);
  },
  updateSoukouMile(
    { commit }: ActionContext<CarSelectData, any>,
    payload: number
  ): void {
    commit("updateSoukouMile", payload);
  },
  updateSoukouUnitKbn(
    { commit }: ActionContext<CarSelectData, any>,
    payload: number
  ): void {
    commit("updateSoukouUnitKbn", payload);
  },
  updateSoukouBikouKbn(
    { commit }: ActionContext<CarSelectData, any>,
    payload: number
  ): void {
    commit("updateSoukouBikouKbn", payload);
  }
};

const mutations = {
  setState(state: CarSelectData, payload: CarSelectData) {
    Object.assign(state, payload);
  },
  clearState(state: CarSelectData) {
    Object.assign(state, { ...initialState });
  },
  updateSoukou(state: CarSelectData, payload: number) {
    state.soukouKm = payload;
  },
  updateSoukouMile(state: CarSelectData, payload: number) {
    state.soukouMile = payload;
  },
  updateSoukouUnitKbn(state: CarSelectData, payload: number) {
    state.soukouUnitKbn = +payload;
  },
  updateSoukouBikouKbn(state: CarSelectData, payload: number) {
    state.soukouBikouKbn = +payload;
  }
};

const getters: GetterTree<CarSelectData, any> = {
  currentState(state: CarSelectData): any {
    return state;
  },
  katashiki(state: CarSelectData): any {
    return state.katashiki;
  },
  engineKatashiki(state: CarSelectData): any {
    return state.engineKatashiki;
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
